<ng-container *ngIf="!isFetching">
    <div class="header">
        <button class="return" mat-flat-button color="primary" (click)="return()">Retour</button>
        <app-invoice-header [invoice]="invoice" [client]="client" [project]="project" (invoiceChange)="updateInvoice($event)" (selectedEntity)="selectedEntity = $event" (selectedBankAccount)="onAccountChange($event)"></app-invoice-header>
    </div>
    <div class="content">
        <app-invoice-lines-card [invoice]="invoice" [service]="service" [project]="project" [hasInvoiceBeenValidated]="hasInvoiceBeenValidated" (generatePdf)="generatePdf()" (validate)="onValidate()"></app-invoice-lines-card>
        <app-invoice-preview [dataUrl]="dataUrl" (generateInvoice)="generatePdfWithFacturx()"></app-invoice-preview>
    </div>
</ng-container>